import { render, staticRenderFns } from "./contentsModel.vue?vue&type=template&id=6756dc21&scoped=true&"
import script from "./contentsModel.vue?vue&type=script&lang=js&"
export * from "./contentsModel.vue?vue&type=script&lang=js&"
import style0 from "./contentsModel.vue?vue&type=style&index=0&id=6756dc21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6756dc21",
  null
  
)

export default component.exports